import { BREAKPOINTS } from "../../utils/breakpoints";

// Для CSS-in-JS (styled-components, emotion)
// Для Stylus используйте миксины из breakpoints.styl

export const BREAKPOINT_VALUES = BREAKPOINTS;

export const MEDIA_QUERIES = {
    mobile: `@media (max-width: ${BREAKPOINTS.S}px)`,
    tablet: `@media (max-width: ${BREAKPOINTS.L}px)`,
    desktop: `@media (min-width: ${BREAKPOINTS.XL}px)`,
    hover: "@media (hover: hover) and (pointer: fine)",
    touch: "@media (hover: none) and (pointer: coarse)",
    /** Для ТВ и устройств с точным указателем (мышь). Не используйте без необходимости! */
    desktopWithHover: `@media (hover: hover) and (pointer: fine) and (min-width: ${BREAKPOINTS.XL}px)`,
} as const;
